import React, { useEffect } from "react";
import ScreeningCountAnalysis from "../components/home/screening-count-analysis/ScreeningCountAnalysis";
import NCDRiskAnalysis from "../components/home/ncd-risk-analysis/NcdRiskAnalysis";
import WorkersList from "../components/home/work-list/WorkList";
import Readings from "../components/home/readings/Readings";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  dynamicClear,
  getMyOrganization,
  getMyOrganizationRequest,
  getReadingClear,
  getSubjectClear,
} from "@src/redux";

type Props = {};

const Home = (props: Props) => {
  const { result: getMyOrg } = useSelector(getMyOrganization);
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(dynamicClear("get_reading_details"));
    dispatch(getReadingClear());
    dispatch(getSubjectClear());
    dispatch(getMyOrganizationRequest({}));
  }, []);
  return (
    <div>
      {getMyOrg?.rootOrganization?.hasPopulationCount && (
        <ScreeningCountAnalysis />
      )}
      <NCDRiskAnalysis />
      <WorkersList />
      <Readings />
    </div>
  );
};

export default Home;
